export default "/images/animation.png?9c992e07c0d33de5e91fd9b7a96c2ba3";